<template>
  <!--
    A basic ass layout. You get a content area and a footer if you wish.
  -->
  <div class="plain-layout">
    <div class="content">
      <RouterView />
    </div>

    <div class="footer">
      <slot name="footer">
        <ApplicationFooter />
      </slot>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { ApplicationFooter } from "@versatile-credit-apply/components"

  interface Slots {
    default: never
    footer: never
  }

  defineSlots<Slots>()
</script>

<style lang="css" scoped>
  @reference "@/main.css";

  .plain-layout {
    @apply grid min-h-screen gap-4 p-4;

    grid-template:
      "content" 1fr
      "footer" max-content
      / 1fr;
  }

  .plain-layout .content {
    @apply grid;
    grid-area: content;
  }

  .plain-layout .footer {
    @apply grid place-items-center;
    grid-area: footer;
  }
</style>
